import React from 'react';


export default function PageNotFound() {
  return <p> Page Not found </p>;
}



// WEBPACK FOOTER //
// ./src/shared/components/PageNotFound.js